import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons

// core components
import Button from "../../components/CustomButtons/Button.jsx";

import Reply from "@material-ui/icons/Reply";

import headerLinksStyle from "../../assets/jss/material-dashboard-pro-react/components/headerLinksStyle";
import { hist } from "../../index";

class HeaderLinks extends React.Component {
  state = {};

  backToCategoryList = () => {
    hist.push("/admin/manageDeclarations");
  };

  render() {
    const { classes } = this.props;
    return (
      <div className="header_main_links">
        <div className="new_Card">
          <Button
            color="facebook"
            round
            className={classes.marginRight}
            onClick={this.backToCategoryList}
          >

            <Reply className={classes.icons} />

            Back
          </Button>
        </div>
      </div>
    );
  }
}

HeaderLinks.propTypes = {
  classes: PropTypes.object.isRequired,
  rtlActive: PropTypes.bool,
};

export default connect(null)(withStyles(headerLinksStyle)(HeaderLinks));
